module.exports = __webpack_public_path__ + "static/media/screenshot-4.d0ceb8db.png";